import React, { Fragment, useEffect, useState } from "react";
import { backend, API_URL } from "../../../config";
import {
  Typography,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Button,
  Modal,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  Divider,
  Switch,
  Collapse,
  IconButton,
  useTheme,
  Tooltip,
  Stack,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import { Link } from "react-router-dom";

import PrintIcon from "@mui/icons-material/Print";

const useStyles = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const columns = [
  {
    id: "ignore_missing_items",
    label: "Ignore Qty Diff",
  },
  {
    id: "inventory_item",
    label: "Inventory Item",
  },
  {
    id: "base_unit_quantity",
    label: "Units Picked",
  },
  {
    id: "units_ordered",
    label: "Units Ordered",
  },
  {
    id: "unit_quantity_to_ordered_difference",
    label: "Unit Difference",
  },
  {
    id: "base_case_quantity",
    label: "Cases Picked",
  },
  {
    id: "cases_ordered",
    label: "Cases Ordered",
  },
  {
    id: "case_quantity_to_ordered_difference",
    label: "Case Difference",
  },
];

const MissingItems = (props) => {
  const {
    currentPricing,
    dateRange,
    orders,
    ordersSelected,
    receiptsSelected,
    priceMargin,
    showPricingDifferences,
    rdErrorsSet,
  } = props.location.state;

  const classes = useStyles();
  const theme = useTheme();

  const [ordersIncluded, setOrdersIncluded] = useState([]);
  const [receipts, setReceipts] = useState([]);
  const [rdData, setRdData] = useState(null);
  const [rdDataFull, setRdDataFull] = useState(null);
  const [rdErrors, setRdErrors] = useState([]);
  const [rdErrorsFull, setRdErrorsFull] = useState([]);
  const [rdOrders, setRdOrders] = useState([]);
  const [rdOrdersFull, setRdOrdersFull] = useState([]);
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [hideErrors, setHideErrors] = useState(false);
  const [displayDetails, setDisplayDetails] = useState(false);
  const [displayPrint, setDisplayPrint] = useState(false);
  const [hiddenItems, setHiddenItems] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);

  const toggleDisplayPrint = () => setDisplayPrint(!displayPrint);

  const toggleDisplayDetails = () => setDisplayDetails(!displayDetails);

  const toggleLoadingModal = () => setLoadingFlag(!loadingFlag);

  const loadingModalContent = (
    <div className={classes.modal}>
      {loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Calculating receipt information <br />
              This may take some time relative to the number of items
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while calculating the receipt information
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                <div style={{ overflow: "scroll", width: 400, height: 300 }}>
                  <div
                    dangerouslySetInnerHTML={{ __html: errorInfo.message }}
                  />
                </div>
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => toggleLoadingModal()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <></>
      )}
    </div>
  );

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);

  const confirmModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to ignore the marked items?
          <br />
          <br />
          <div align="right">
            <Button onClick={() => toggleConfirmModal()}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequest()}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Saving differences
              <br />
              This may take some time relative to the number of items marked
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while saving the differences
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveError()}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          Differences have been successfully saved
          <br />
          <br />
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const resolveRequest = () => {
    setFinishedFlag(false);
    setLoadingFlag(false);
    setHiddenItems(false);

    toggleConfirmModal();
  };

  const resolveError = () => {
    setFinishedFlag(false);
    setLoadingFlag(false);
    setHiddenItems(false);
    setErrorInfo({ error: false, message: "" });

    toggleConfirmModal();
  };

  const sendRequest = async () => {
    setLoadingFlag(true);

    let differencesToHide = [];

    rdDataFull.difference_groups.forEach((dgItem) =>
      dgItem.differences.forEach((dItem) => {
        if (dItem.hidden) differencesToHide.push(dItem);
      })
    );

    if (differencesToHide.length) {
      let errorMsg = "";

      Promise.all(
        differencesToHide.map(async (dItem) => {
          if (!dItem?.order_item?.referenced_order_items?.length)
            return Promise.reject("No referenced order items found");

          return await Promise.all(
            dItem.order_item?.referenced_order_items.map(
              async (roiItem) =>
                await backend
                  .patch(`${API_URL}orderitems/${roiItem}`, {
                    ignore_missing_items: true,
                  })
                  .then(({ data }) => {
                    return Promise.resolve(data?.ignore_missing_items || true);
                  })
                  .catch((error) => {
                    console.log(error);
                    errorMsg +=
                      "\nThere was an error processing order item: " + roiItem;

                    return Promise.reject(error);
                  })
            )
          )
            .then((result) => {
              const isIgnored = result.every((value) => value);

              return Promise.resolve({
                uniqId: dItem.uniqId,
                isIgnored: isIgnored,
              });
            })
            .catch((error) => {
              console.log(error);
              return Promise.reject(error);
            });
        })
      )
        .then((result) => {
          setRdDataFull((prevState) => {
            let differenceGroups = prevState.difference_groups.map((dgItem) => {
              let differencesMap = dgItem.differences.map((dItem) => {
                let differenceItemObj = dItem;

                const ignoredItemFound = result.find(
                  (item) => item.uniqId === dItem.uniqId
                );

                if (ignoredItemFound) {
                  differenceItemObj = {
                    ...differenceItemObj,
                    hidden: ignoredItemFound.isIgnored,
                    order_item: {
                      ...differenceItemObj.order_item,
                      ignore_missing_items: ignoredItemFound.isIgnored,
                    },
                  };
                }

                return differenceItemObj;
              });

              return { ...dgItem, differences: differencesMap };
            });

            console.log({ ...prevState, difference_groups: differenceGroups });

            return { ...prevState, difference_groups: differenceGroups };
          });

          if (errorMsg) {
            setErrorInfo({ error: true, message: errorMsg });
          } else {
            resolveRequest();
          }
        })
        .catch((error) => {
          console.log(error);

          if (errorMsg) {
            setErrorInfo({ error: true, message: errorMsg });
          }
        });
    }
  };

  const handleChangeErrorFiltering = (e) => {
    const { checked, value } = e.target;

    if (checked) {
      setRdErrors((prevState) => [...prevState, value]);
    } else {
      setRdErrors((prevState) =>
        prevState.filter((item) => {
          return item !== value;
        })
      );
    }
  };

  const handleChangeOrderFiltering = (e) => {
    const { checked, value } = e.target;

    if (checked) {
      setRdOrders((prevState) => [...prevState, +value]);
    } else {
      setRdOrders((prevState) =>
        prevState.filter((item) => {
          return item !== +value;
        })
      );
    }
  };

  const handleChange = (e) => {
    const { checked, name } = e.target;
    const [, , , uniqId] = name.split("-");

    setRdDataFull((prevState) => {
      let differenceGroups = prevState.difference_groups.map((dgItem) => {
        let differencesMap = dgItem.differences;

        const uniqIdFound = differencesMap.find(
          (item) => item.uniqId === +uniqId
        );

        if (uniqIdFound) {
          differencesMap = differencesMap.map((item) => {
            if (item.uniqId === +uniqId) {
              return {
                ...item,
                hidden: checked,
              };
            }

            return item;
          });
        }

        return { ...dgItem, differences: differencesMap };
      });

      return { ...prevState, difference_groups: differenceGroups };
    });
  };

  useEffect(() => {
    const rdResultsGet = async () => {
      setLoadingFlag(true);

      const payloadObj = {
        order_ids: ordersIncluded,
        receipt_ids: receipts,
        use_current_pricing: currentPricing,
        price_margin: priceMargin,
        show_pricing_differences: showPricingDifferences,
      };

      await backend
        .post(`${API_URL}receiptdifferenceresult`, payloadObj)
        .then(({ data }) => {
          let rdErrorsArray = [];
          let rdOrdersArray = [];

          let dataMap = {};

          let uniqueId = 0;

          if (data.difference_groups.length) {
            const differenceGroupsMap = data.difference_groups
              .filter((dgItem) =>
                dgItem.differences.some((difference) => {
                  if (difference.order_item === null) return false;

                  if (difference.product.out_of_stock) return false;

                  if (difference.order_item.ignore_missing_items) return false;

                  if (
                    difference.order_item
                      .unit_quantity_to_ordered_difference !== 0 ||
                    difference.order_item
                      .case_quantity_to_ordered_difference !== 0
                  )
                    return true;

                  return false;
                })
              )
              .sort((a, b) => {
                const aBin = a?.differences[0]?.product?.bin_normalized;
                const bBin = b?.differences[0]?.product?.bin_normalized;

                if (isNaN(+aBin) && isNaN(+bBin)) {
                  if (aBin > bBin) {
                    return 1;
                  }
                  if (aBin < bBin) {
                    return -1;
                  }
                  return 0;
                }

                if (isNaN(+aBin)) return 1;
                if (isNaN(+bBin)) return -1;

                if (+aBin > +bBin) {
                  return 1;
                }
                if (+aBin < +bBin) {
                  return -1;
                }

                return 0;
              })
              .map((dgItem) => {
                if (
                  !rdErrorsArray.includes("DifferenceCategory.OUT_OF_STOCK") &&
                  dgItem.difference_categories.includes(
                    "DifferenceCategory.OUT_OF_STOCK"
                  )
                ) {
                  rdErrorsArray.push("DifferenceCategory.OUT_OF_STOCK");
                }

                dgItem.differences.forEach((difference) => {
                  if (difference.order_item === null) return;

                  const referencedOrdersId =
                    difference.order_item.referenced_orders.map(
                      (roItem) => roItem.order_id
                    );

                  rdOrdersArray = [...rdOrdersArray, ...referencedOrdersId];
                });

                const differencesMap = dgItem.differences.map((dItem) => {
                  uniqueId = uniqueId + 1;

                  return {
                    ...dItem,
                    hidden: false,
                    uniqId: uniqueId,
                  };
                });

                return { ...dgItem, differences: differencesMap };
              });

            dataMap = { ...data, difference_groups: differenceGroupsMap };
          }

          rdOrdersArray = [...new Set(rdOrdersArray)].sort((a, b) => a - b);

          setRdData(dataMap);
          setRdDataFull(dataMap);
          setRdErrors(rdErrorsArray);
          setRdErrorsFull(rdErrorsArray);
          setRdOrders(rdOrdersArray);
          setRdOrdersFull(rdOrdersArray);
          setLoadingFlag(false);

          console.log(dataMap);
        })
        .catch((error) => {
          console.log(error);
          setErrorInfo({
            error: true,
            message: error.response.data.includes("<html")
              ? error.response.data
              : JSON.stringify(error.response.data),
          });
        });
    };

    if (ordersIncluded.length && receipts.length) {
      rdResultsGet();
    }
  }, [
    currentPricing,
    dateRange,
    ordersIncluded,
    receipts,
    priceMargin,
    showPricingDifferences,
  ]);

  useEffect(() => {
    const ordersMap = ordersSelected.map((item) => item.id);

    setOrdersIncluded(ordersMap);
  }, [ordersSelected]);

  useEffect(() => {
    setReceipts(receiptsSelected.map((item) => item.id));
  }, [receiptsSelected]);

  useEffect(() => {
    const hideErrorsFunc = () => {
      setRdErrors(() => (hideErrors ? [] : rdErrorsFull));
    };

    if (!loadingFlag) {
      hideErrorsFunc();
    }
  }, [hideErrors, loadingFlag, rdErrorsFull]);

  useEffect(() => {
    const filterRdData = () => {
      setRdData(() => {
        const errorsToHide = rdErrorsFull.filter(
          (eItem) => !rdErrors.includes(eItem)
        );

        const differenceGroups = rdDataFull.difference_groups.filter((item) => {
          if (!item.difference_categories.length) return true;

          return item.difference_categories.some((dcItem) =>
            errorsToHide.length ? !errorsToHide.includes(dcItem) : true
          );
        });

        return { ...rdDataFull, difference_groups: differenceGroups };
      });

      if (rdErrorsFull.length && !rdErrors.length) {
        setHideErrors(true);
      }
    };

    const hiddenItemsCheck = () => {
      const hiddenItemsFound = rdDataFull.difference_groups.some((dgItem) =>
        dgItem.differences.some(
          (dItem) => dItem.hidden && !dItem?.order_item?.ignore_missing_items
        )
      );

      setHiddenItems(hiddenItemsFound);
    };

    if (rdDataFull && !loadingFlag) {
      filterRdData();
      hiddenItemsCheck();
    }
  }, [loadingFlag, rdDataFull, rdErrors, rdErrorsFull]);

  return (
    <div className={classes.paper}>
      <Modal open={rdDataFull === null && loadingFlag}>
        {loadingModalContent}
      </Modal>
      <Modal open={confirmModal} onClose={() => resolveRequest()}>
        {confirmModalContent}
      </Modal>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} style={{ textAlign: "right" }}>
          {rdData && rdData.difference_groups.length ? (
            <IconButton
              style={{ marginLeft: theme.spacing(1) }}
              variant="contained"
              onClick={() => toggleDisplayPrint()}
            >
              <PrintIcon color={displayPrint ? "info" : "inherit"} />
            </IconButton>
          ) : (
            <IconButton
              style={{ marginLeft: theme.spacing(1) }}
              variant="contained"
            >
              <PrintIcon color="disabled" />
            </IconButton>
          )}
        </Grid>
        <Grid item xs={12} sm={12}>
          <Divider textAlign="right">
            <Tooltip title={`${displayDetails ? "Show" : "Hide"} details`}>
              <Switch
                checked={!displayDetails}
                onChange={() => toggleDisplayDetails()}
              />
            </Tooltip>
          </Divider>
          <Collapse in={!displayDetails}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <Typography variant="subtitle1">
                  <strong>Start Date: </strong>
                  {!isNaN(dateRange[0])
                    ? dateRange[0].toISOString().split("T")[0]
                    : dateRange[0].split("T")[0]}
                </Typography>
                <Typography variant="subtitle1">
                  <strong>End Date: </strong>
                  {!isNaN(dateRange[1])
                    ? dateRange[1].toISOString().split("T")[0]
                    : dateRange[1].split("T")[0]}
                </Typography>
                <Typography variant="subtitle1">
                  <strong>Included Orders: </strong>
                  {ordersIncluded.map((item) => {
                    const orderObj = orders.find((order) => order.id === item);
                    return `${item} (${orderObj.customer.username}),`;
                  })}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                {rdErrorsFull.length ? (
                  <>
                    <Typography variant="subtitle1">
                      <strong>Error filtering </strong>
                    </Typography>
                    {rdErrorsFull.map((item, idx) => (
                      <FormControlLabel
                        key={`rdError-${idx}`}
                        value="start"
                        control={
                          <Checkbox
                            name={`rdError-${idx}`}
                            value={item}
                            checked={rdErrors.includes(item)}
                            onChange={handleChangeErrorFiltering}
                            color="primary"
                          />
                        }
                        label={item.replace("DifferenceCategory.", "")}
                        labelPlacement="end"
                      />
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </Grid>
              <Grid item xs={9}>
                {rdOrdersFull.length ? (
                  <>
                    <Typography variant="subtitle1">
                      <strong>Order filtering </strong>
                    </Typography>
                    {rdOrdersFull.map((item, idx) => (
                      <FormControlLabel
                        key={`rdOrder-${idx}`}
                        value="start"
                        control={
                          <Checkbox
                            name={`rdError-${idx}`}
                            value={item}
                            checked={rdOrders.includes(item)}
                            onChange={handleChangeOrderFiltering}
                            color="primary"
                          />
                        }
                        label={item}
                        labelPlacement="end"
                      />
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
          </Collapse>
        </Grid>
        <Grid item xs={12}>
          <TableContainer sx={{ maxHeight: displayPrint ? "auto" : 600 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={`header-${column.id}`}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rdData && rdData.difference_groups.length ? (
                  rdData.difference_groups.map((group, index) =>
                    group.differences
                      .filter((difference) => {
                        if (!rdOrders.length) return true;

                        if (!difference.order_item) return true;

                        if (!difference.order_item.referenced_orders)
                          return true;

                        return difference.order_item.referenced_orders.some(
                          (roItem) => rdOrders.includes(roItem.order_id)
                        );
                      })
                      .filter((difference) => {
                        if (difference.order_item === null) return false;

                        if (difference.product.out_of_stock) return false;

                        if (difference.order_item.ignore_missing_items)
                          return false;

                        if (
                          difference.order_item
                            .unit_quantity_to_ordered_difference !== 0 ||
                          difference.order_item
                            .case_quantity_to_ordered_difference !== 0
                        )
                          return true;

                        return false;
                      })
                      .map(
                        (
                          { order_item, product, receipt_item, hidden, uniqId },
                          indexIn
                        ) => (
                          <TableRow
                            hover
                            tabIndex={-1}
                            key={`group-${index}-row-${indexIn}`}
                            style={{
                              background:
                                group.differences.length > 1
                                  ? "repeating-linear-gradient(45deg, transparent, transparent, rgb(195, 195, 195) 30px, rgb(245, 245, 245) 10px) fixed"
                                  : "inherit",
                              backgroundColor:
                                group.difference_categories.includes(
                                  "DifferenceCategory.NO_RECEIPT_ITEM"
                                ) ||
                                group.difference_categories.includes(
                                  "DifferenceCategory.NO_ORDER_ITEM"
                                )
                                  ? "#fcf8e3"
                                  : group.difference_categories.includes(
                                      "DifferenceCategory.UNIT_QUANTITY"
                                    ) ||
                                    group.difference_categories.includes(
                                      "DifferenceCategory.CASE_QUANTITY"
                                    ) ||
                                    group.difference_categories.includes(
                                      "DifferenceCategory.PRICE"
                                    )
                                  ? "#f2dede"
                                  : "inherit",
                            }}
                          >
                            <TableCell>
                              <Checkbox
                                name={`${index}-${indexIn}-ignore-${uniqId}`}
                                value={hidden}
                                checked={hidden}
                                onChange={handleChange}
                              />
                            </TableCell>
                            <TableCell>
                              {product !== null ? (
                                <>
                                  <Typography variant="subtitle1">
                                    <strong>UPC: </strong>
                                    {product.upc}
                                  </Typography>
                                  <Typography variant="subtitle1">
                                    <strong>Item Code: </strong>
                                    {product.item_code}
                                  </Typography>
                                  <Typography variant="subtitle1">
                                    {product.name}
                                  </Typography>
                                  {order_item !== null &&
                                  order_item?.referenced_orders ? (
                                    <Typography variant="subtitle1">
                                      <strong>Order: </strong>
                                      {order_item.referenced_orders.map(
                                        (oiRef) => {
                                          const orderObj = orders.find(
                                            (oItem) =>
                                              oItem.id === oiRef.order_id
                                          );

                                          return (
                                            <Fragment
                                              key={`${product.upc}-${oiRef.order_id}`}
                                            >
                                              {oiRef.order_id}
                                              {` (${orderObj.customer.username})`}
                                              {oiRef.base_unit_quantity ||
                                              oiRef.units_ordered
                                                ? ` U: ${oiRef.base_unit_quantity}/${oiRef.units_ordered}`
                                                : ""}
                                              {oiRef.base_case_quantity ||
                                              oiRef.cases_ordered
                                                ? ` C: ${oiRef.base_case_quantity}/${oiRef.cases_ordered}`
                                                : ""}
                                              <br />
                                            </Fragment>
                                          );
                                        }
                                      )}
                                    </Typography>
                                  ) : (
                                    <></>
                                  )}
                                  <Typography variant="subtitle1">
                                    <strong>Bin: </strong>
                                    {`${product.bin_normalized || "N/A"}`}
                                  </Typography>
                                  <Typography variant="subtitle1">
                                    <strong>Combined Stock: </strong>
                                    {`${product.combined_stock_level || "N/A"}`}
                                  </Typography>
                                </>
                              ) : (
                                <></>
                              )}
                            </TableCell>
                            <TableCell>
                              {order_item !== null ? (
                                <>
                                  <Typography variant="h5">
                                    {order_item.base_unit_quantity}
                                  </Typography>
                                </>
                              ) : (
                                <>N/A</>
                              )}
                            </TableCell>
                            <TableCell>
                              {order_item !== null ? (
                                <>
                                  <Typography variant="h5">
                                    {order_item.units_ordered}
                                  </Typography>
                                </>
                              ) : (
                                <>N/A</>
                              )}
                            </TableCell>
                            <TableCell>
                              {order_item !== null ? (
                                <>
                                  <Typography
                                    variant="h5"
                                    style={{ color: "red", fontWeight: "bold" }}
                                  >
                                    {
                                      order_item.unit_quantity_to_ordered_difference
                                    }
                                  </Typography>
                                </>
                              ) : (
                                <>N/A</>
                              )}
                            </TableCell>
                            <TableCell>
                              {order_item !== null ? (
                                <Typography variant="h5">
                                  {order_item.base_case_quantity}
                                </Typography>
                              ) : (
                                <>N/A</>
                              )}
                            </TableCell>
                            <TableCell>
                              {order_item !== null ? (
                                <>
                                  <Typography variant="h5">
                                    {order_item.cases_ordered}
                                  </Typography>
                                </>
                              ) : (
                                <>N/A</>
                              )}
                            </TableCell>
                            <TableCell>
                              {order_item !== null ? (
                                <>
                                  <Typography
                                    variant="h5"
                                    style={{ color: "red", fontWeight: "bold" }}
                                  >
                                    {
                                      order_item.case_quantity_to_ordered_difference
                                    }
                                  </Typography>
                                </>
                              ) : (
                                <>N/A</>
                              )}
                            </TableCell>
                          </TableRow>
                        )
                      )
                  )
                ) : (
                  <TableRow>
                    <TableCell colSpan={8}>
                      There are no difference results or they are all hidden
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12}>
          <Stack
            direction="row"
            spacing={1}
            style={{ justifyContent: "right" }}
          >
            <Link
              to={{
                pathname: "/receiptDifference",
                state: {
                  currentPricing: currentPricing,
                  dateRange: dateRange,
                  orders: orders,
                  ordersSelected: ordersSelected,
                  receiptsSelected: receiptsSelected,
                  priceMargin: priceMargin,
                  showPricingDifferences: showPricingDifferences,
                  rdErrorsSet: rdErrorsSet,
                },
              }}
            >
              <Button>Back</Button>
            </Link>
            <Button
              variant="contained"
              color="primary"
              onClick={() => toggleConfirmModal()}
              disabled={!hiddenItems}
            >
              Save
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </div>
  );
};

export default MissingItems;
